/**
 * Success message component after email submission
 * Uses constants for all text content
 */

import { cn } from "../../lib/utils";
import { PRE_LAUNCH_CONTENT } from "../../constants/preLaunch";

export function SuccessMessage() {
  return (
    <div className="max-w-md mx-auto px-4 text-center">
      {/* Success icon */}
      <div className="inline-flex items-center justify-center mb-4">
        <img
          src="/success-check.png"
          alt="Success"
          className="w-16 h-16 sm:w-20 sm:h-20"
          aria-label="Success check mark"
        />
      </div>

      {/* Success heading - High contrast white */}
      <h2 className={cn("text-2xl sm:text-3xl font-bold mb-3 text-white font-sans")}>
        {PRE_LAUNCH_CONTENT.success.title}
      </h2>

      {/* Success message - Accessible contrast */}
      <p className={cn("text-lg text-text-primary font-sans")}>
        {PRE_LAUNCH_CONTENT.success.message}
      </p>
    </div>
  );
}
